module.exports = __webpack_public_path__ + "media/images/icons/twotone/insurance-fecfe2aaf857257ca35518436ae1a9c6.svg";